if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
          copyButton: this.querySelector('.share-button__copy-btn')
        };

        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (this.elements.copyButton) {
          this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.urlToShare).then(() => {
          if (!this.elements.successMessage) return;
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = 'Copied!';
          setTimeout(() => {
            this.elements.successMessage.classList.add('hidden');
          }, 2000);
        });
      }
    }
  );
}
